var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 11.1719V1.56287C0.25 1.19837 0.3775 0.888366 0.6325 0.632866C0.888 0.377866 1.198 0.250366 1.5625 0.250366H11.437C11.8015 0.250366 12.1115 0.377866 12.367 0.632866C12.622 0.888366 12.7495 1.19837 12.7495 1.56287V8.93762C12.7495 9.30212 12.622 9.61212 12.367 9.86762C12.1115 10.1226 11.8015 10.2501 11.437 10.2501H2.74975L1.375 11.6249C1.1665 11.8334 0.92675 11.8829 0.65575 11.7734C0.38525 11.6639 0.25 11.4634 0.25 11.1719ZM1.5625 9.57812L2.203 8.93762H11.437V1.56287H1.5625V9.57812Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubble);
export default __webpack_public_path__ + "static/media/chat_bubble.af41131375093c043e05a4f9f39287ae.svg";
export { ForwardRef as ReactComponent };